module.exports = __webpack_public_path__ + "static/media/battles-tooltip.76cf13fe.png";